/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentTemplateParser = /* #__PURE__ */ parsers.object([
    ['assignmentId', codecNumber, 'assignment_id'],
]);
export class AssignmentTemplate extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentTemplateParser.decode(input).map(res => new AssignmentTemplate(res));
    }
    static unsafeDecode(input) {
        return AssignmentTemplate.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentTemplateParser.encode(data);
    }
    static schema() {
        return AssignmentTemplateParser.schema();
    }
}
